const QuestionTypes = {
  MULTIPLE_CHOICE: "MULTIPLE_CHOICE",
  PARAGRAPH_TEXT: "PARAGRAPH_TEXT",
  TEXT: "TEXT",
};

export default QuestionTypes;
